
import React, { useEffect, useState } from "react";
import { ReportAPI } from "../../api/apiClient";

interface Props {
  projectId: number;
  //selectedDate: string;
}

interface VendorCount {
  vendor: string;
  count: number;
}

interface WorkforceResponse {
  totalWorkforce: number;
  vendors: VendorCount[];
}

export default function DailyTotalWorkforceReport({
  projectId,
  //selectedDate,
}: Props) {
  const [data, setData] = useState<WorkforceResponse | null>(null);
  const [loading, setLoading] = useState(false);

  // Auto load when projectId changes

  useEffect(() => {
   // if (!selectedDate) return;
   if (!projectId) return;


    const loadReport = async () => {
      try {
        setLoading(true);

        const result = await ReportAPI.getDailyTotalWorkforce({
          //qDate: selectedDate,
          //endDate: selectedDate,
          project: projectId,
          vendor: -1,
          cmp: 0,
        });

        setData(result as WorkforceResponse);
      } catch (err) {
        console.error("Workforce API error:", err);
      } finally {
        setLoading(false);
      }
    };

    loadReport();
  }, [projectId]); //selectedDate

  return (
   // <div className="bg-white rounded shadow border overflow-hidden">
<div className="bg-white rounded-2xl shadow-md border border-gray-200 overflow-hidden">

    {/*<div className="bg-white rounded shadow border overflow-hidden max-w-md ">*/}
    


      {/* Header */}
      {/*<div className="bg-blue-800 text-white px-4 py-3 font-semibold flex justify-between">*/}
      <div className="bg-[#1788ac] text-white px-4 py-3 font-semibold flex justify-between">


        <span>TOTAL WORKFORCE</span>
        <span>{data?.totalWorkforce ?? 0}</span>
      </div>

      {/* Body */}
      <div className="p-4 space-y-2">
        {/* p-4 space-y-2 */}

        {loading && (
          <div className="text-gray-500">Loading...</div>
        )}

        {!loading && data?.vendors?.length === 0 && (
          <div className="text-gray-500">No data found.</div>
        )}

        {!loading &&
          data?.vendors?.map((v) => (
            <div
              key={v.vendor}
              className="flex justify-between text-gray-800 text-base " 
            > 
            {/*this is first flex justify-between text-gray-800 text-base */}
            {/* <div className="flex items-center justify-between text-sm py-1">*/}
              <span>{v.vendor}</span>
              <span className="font-semibold">{v.count}</span>
            </div>
          ))}
      </div>

      {/* Bottom Accent */}
      {/*<div className="h-1 bg-green-600"></div>*/}
    </div>
  );
}
 

